export default "__VITE_ASSET__Pfyf84zC__"